/* istanbul ignore file */
import { useEffect, useState } from 'react'
import classnames from 'classnames/bind'
import { Text, SimpleMap } from '@adc/ui-adc'
import { helpers } from '@adc/core-utils'
import styles from './styles.scss'
const cx = classnames.bind(styles)

type MapProps = {
  marker: { lat: number; lng: number }
  address: string
}
const Map = ({ marker, address }: MapProps) => {
  const [isGmapsLoaded, setIsGmapsLoaded] = useState(false)

  useEffect(() => {
    // WHY: google-map-react library loads the gmaps scripts when the component
    // is first rendered so if they are not in memory (window.google is not set)
    // before component finishes rendering map will not display until there
    // had been a state update that forces a refresh
    // (this is due to the way getBounds is written)
    const checkGmaps = setInterval(() => {
      // @ts-ignore next
      if (helpers.environments.canUseDom() && window?.google) {
        setIsGmapsLoaded(true)
        clearInterval(checkGmaps)
      }
    }, 100)

    return () => clearInterval(checkGmaps)
  }, [])

  if (!isGmapsLoaded) {
    return null
  }

  return (
    <div className={cx('container')}>
      <div className={cx('map-container')}>
        <SimpleMap
          coords={marker}
          createMapOptions={() => ({
            draggableCursor: 'default',
            zoomControl: true,
          })}
        />
        <Text.Header level={2} color='gray' className={cx('u-mt-4', 'address')}>
          {address}
        </Text.Header>
      </div>
    </div>
  )
}

export default Map
